"use strict";
var _MavenGraphBuilder_graph;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MavenGraphBuilder = void 0;
const tslib_1 = require("tslib");
class MavenGraphBuilder {
    constructor(rootId) {
        _MavenGraphBuilder_graph.set(this, void 0);
        tslib_1.__classPrivateFieldSet(this, _MavenGraphBuilder_graph, {
            rootId,
            nodes: {
                [rootId]: { dependsOn: [], parents: [], reachesProdDep: false },
            },
        }, "f");
    }
    findOrCreateNode(id) {
        return this.findNode(id) || this.createNode(id);
    }
    findNode(id) {
        return tslib_1.__classPrivateFieldGet(this, _MavenGraphBuilder_graph, "f").nodes[id];
    }
    createNode(id) {
        const node = { dependsOn: [], parents: [], reachesProdDep: false };
        tslib_1.__classPrivateFieldGet(this, _MavenGraphBuilder_graph, "f").nodes[id] = node;
        return node;
    }
    markNodeProdReachable(id) {
        const node = this.findNode(id);
        if (node && !node.reachesProdDep) {
            node.reachesProdDep = true;
            for (const parentId of node.parents) {
                this.markNodeProdReachable(parentId);
            }
        }
    }
    connect(parentId, id) {
        const parentNode = this.findOrCreateNode(parentId);
        const childNode = this.findOrCreateNode(id);
        if (!childNode.parents.includes(parentId)) {
            childNode.parents.push(parentId);
        }
        if (!parentNode.dependsOn.includes(id)) {
            parentNode.dependsOn.push(id);
        }
        if (!id.endsWith(':test')) {
            this.markNodeProdReachable(id);
        }
    }
    get graph() {
        return tslib_1.__classPrivateFieldGet(this, _MavenGraphBuilder_graph, "f");
    }
}
exports.MavenGraphBuilder = MavenGraphBuilder;
_MavenGraphBuilder_graph = new WeakMap();
//# sourceMappingURL=maven-graph-builder.js.map